import { Component, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { StringCustomFieldConfig, SharedModule, FormInputComponent, DataService } from '@vendure/admin-ui/core';
import { Subscription } from 'rxjs';

@Component({
    template: `
        <input class="clover-ids-form" type="string" [formControl]="formControl" />
    `,
    styleUrls: ['./clover-customer-id.component.scss'],
    standalone: true,
    imports: [SharedModule],
})
export class CloverCustomerIdFormComponent implements FormInputComponent<StringCustomFieldConfig>, OnDestroy {
    readonly!: boolean;
    config!: StringCustomFieldConfig;
    formControl!: FormControl;
    private sub?: Subscription;

    constructor(
        private dataService: DataService,
    ) { }

    ngOnInit() {
        const rawValue = this.formControl.value;
        if (!rawValue) return;

        let parsed: Record<string, string> = {};
        try {
            parsed = JSON.parse(rawValue);
        } catch (err) {
            console.warn('Invalid JSON in CloverCustomerId field:', rawValue);
            return;
        }

        /*this.dataService.client
            .userStatus()
            .mapSingle(({ userStatus }) => userStatus.activeChannelId)
            .subscribe(activeChannelId => {
                if(!activeChannelId){
                    return;
                }

                if (activeChannelId === "1") {
                    // Show all key-value pairs in a readable form
                    const displayValue = Object.entries(parsed)
                        .map(([key, val]) => `Channel ${key}: ${val}`)
                        .join(' | ');
                    this.formControl.setValue(displayValue, { emitEvent: false });
                } else {
                    // Show only current channel value
                    const valueForChannel = parsed[activeChannelId] || '';
                    this.formControl.setValue(valueForChannel, { emitEvent: false });
                }
            });*/

            this.sub = this.dataService.client
            .userStatus()
            .mapStream(({ userStatus }) => userStatus.activeChannelId) // Use mapStream for ongoing updates
            .subscribe(activeChannelId => {
                console.log('Active Channel ID changed to:', activeChannelId);
                if(!activeChannelId){
                    return;
                }

                if (activeChannelId === "1") {
                    // Show all key-value pairs in readable form
                    const displayValue = Object.entries(parsed)
                        .map(([key, val]) => `Channel ${key}: ${val}`)
                        .join(' | ');
                    this.formControl.setValue(displayValue, { emitEvent: false });
                } else {
                    // Show only current channel value
                    const valueForChannel = parsed[activeChannelId] || '';
                    this.formControl.setValue(valueForChannel, { emitEvent: false });
                }
            });

    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }
}
